/**
 * @license
 * Copyright (c) 2021-present, FriendliAI Inc. All rights reserved.
 */

import React from 'react';
import { type RouteObject } from 'react-router-dom';

import TeamSettingsLayout from '@fai/friendli-suite/views/layout/settings/team-settings-layout';

const TeamBillingPage = React.lazy(() => import('@fai/friendli-suite/pages/team-settings/billing'));
const TeamSettingsPage = React.lazy(
  () => import('@fai/friendli-suite/pages/team-settings/settings')
);
const TeamMembersPage = React.lazy(() => import('@fai/friendli-suite/pages/team-settings/members'));

const teamSettingsRoutes: RouteObject[] = [
  {
    Component: TeamSettingsLayout,
    children: [
      {
        path: 'billing',
        Component: TeamBillingPage,
      },
      {
        path: 'settings',
        Component: TeamSettingsPage,
      },
      {
        path: 'members',
        Component: TeamMembersPage,
      },
    ],
  },
];

export { teamSettingsRoutes };
